export default __webpack_public_path__ + "static/media/equilibrio-01.10226bd7.jpg";